import { APICallV3Post } from 'reactApp/api/APICall';

export class BindDeleteAPICall extends APICallV3Post {
    _method = 'billing/bind/delete';
}
